import { useEffect, useState } from "react"
// import { isArray } from "lodash-es";
// import { useApolloClient } from "@apollo/client";
function useFetchIcons(url, params) {
  const options = params && params.options
  // const typename = params && params.typename;

  // const client = useApolloClient();
  const [data, setData] = useState(null)
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      try {
        const res = await fetch(url, options)
        const json = await res.json()
        setData(json)
        setLoading(false)
      } catch (error) {
        setError(error)
      }
    }
    fetchData()
  }, [options, url])
  return { data, error, loading }
}

export default useFetchIcons
